import React from 'react'
import { antdAsyncMessageLoading, antdAsyncMessageSuccess } from "../../helpers/AsyncMessage";
import { errorHandler, exportDocument } from "../../helpers/Utils";

export const exportedDocumentAction = (params) => async (_, getState) => {
  try {
    if (!!params.user_id) {
      const user_id = getState().auth.user.id;
      if (user_id !== params.user_id) return;
    }

    exportDocument(params.api_url, params.name, "POST", {
      file_name: params.name,
    });

    console.log({ params });
    return 1
  } catch (err) {
    errorHandler(err);
    return 0;
  }
};

export const exportedDocumentPercentagesAction =
  (params) => async (_, getState) => {
    try {
      const user_id = getState().auth.user.id;
      if (user_id !== params.user_id) return;
      const element = document.getElementById(params.element);
      if (element) {
        element.innerHTML = params.text;
      } else {
        antdAsyncMessageLoading({
          key: params.element == 'bulk_shipment_progress' ? 'bulk_shipment_progress' : "exportDocument",
          text: <span id={params.element}>{params.text}</span>,
        });
      }
      if (params.text.includes('100%') || params.text.includes('100 %')) {
        setTimeout(() => {
          const element = document.getElementById(params.element);
          if (!element) return
          antdAsyncMessageSuccess({
            key: params.element == 'bulk_shipment_progress' ? 'bulk_shipment_progress' : "exportDocument",
            text: <span id={params.element}>Atlikta</span>,
          });
        }, 2000)

      }
    } catch (err) {
      errorHandler(err);
      return "";
    }
  };
